import React from 'react';
import moment from 'moment';
import { useTeamNews } from '../../hooks/news';
import { getProxyUrl } from '../../utils/image';
import { textExcerpt } from "../../utils/functionalUtils";

function TeamNews({ abbrv, teamName }) {
  const [articles, loading, error] = useTeamNews(abbrv, 4);

  const featuredArticle = articles?.[0];

  const renderArticle = (article) => {
    const fallbackImage = `/wp-content/themes/sef-leagues/images/${article?.abbrv?.toLowerCase()}-fallback.png`;
    const img = article?.image
      ? getProxyUrl(article?.image, 599, 337)
      : fallbackImage;
    return (
      <a
          href={article?.articleUrl}
          title={article?.title}
          target="_blank"
          rel="noopener noreferrer"
          className="article-horizontal text-decoration-none"
      >
        <img
            src={img}
            alt=""
            decoding="async"
            onError={({ currentTarget }) => {
              currentTarget.onerror = null;
              currentTarget.src = "/wp-content/themes/sef-leagues/images/fallback-image-superettan.png";
            }}
        />
        <div className="article-horizontal__info">
          <time
            className="text-small text-color-primary-yellow text-uppercase fw-bold mb-1"
            dateTime="2023-08-28T05:30:16+00:00"
          >
            {moment(article?.dateTime).format('DD MMMM').toUpperCase()}
          </time>
          <h2 className="heading-h5 heading-sm-h5 text-transform-none mb-2">
            {article?.title}
          </h2>
          <p className="text-small text-sm-regular fw-bold d-block d-sm-none">
            {article ? textExcerpt(article.description) : ''}
          </p>
        </div>
      </a>
    );
  };

  if (articles?.length === 0 || !articles) {
    return null;
  }

  return (
    <section className="col-12 mt-5">
      <div className="col-12 d-flex px-sm-3 align-items-center mb-4">
        <h2 className="heading-h6 heading-sm-h3 flex-grow-1">
          {' '}
          NYHETER FÖR {teamName}
        </h2>
      </div>
      <div className="col-12">
        <div className="article__container flex-sm-column flex-lg-row gap-4 gap-sm-2 gap-lg-2">
          <div className="article__featured-container pe-0 pe-lg-2">
            <a
                href={featuredArticle?.articleUrl}
                title={featuredArticle?.title}
                target="_blank"
                rel="noopener noreferrer"
                className="article-featured"
            >
              <img
                src={
                  featuredArticle?.image
                    ? getProxyUrl(featuredArticle?.image, 599, 337)
                    : `/wp-content/themes/sef-leagues/images/${featuredArticle?.abbrv?.toLowerCase()}-fallback.png`
                }
                alt=""
                decoding="async"
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null;
                  currentTarget.src = "/wp-content/themes/sef-leagues/images/fallback-image-superettan.png";
                }}
              />
              <div className="article-featured__info">
                <time
                  className="text-small text-color-primary-yellow text-uppercase fw-bold mb-1"
                  dateTime="2023-08-28T19:28:39+00:00"
                >
                  {' '}
                  {moment(featuredArticle?.dateTime)
                    .format('DD MMMM')
                    .toUpperCase()}
                </time>
                <h2 className="heading-h5 heading-sm-h5 text-transform-none mb-2">
                  {featuredArticle?.title}
                </h2>
                <p className="text-small text-sm-regular fw-bold">
                  {featuredArticle ? textExcerpt(featuredArticle.description) : ''}
                </p>
              </div>
            </a>
          </div>
          <div className="article__list-container flex-sm-row flex-lg-column flex-grow-1 gap-4 gap-sm-3 gap-lg-0">
            {articles?.slice(1, 4).map(renderArticle)}
          </div>
        </div>
      </div>
    </section>
  );
}

export default TeamNews;
